/**
 * Swiper Vue 6.5.0
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2021 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: March 5, 2021
 */

import { Swiper } from './esm/vue/swiper';
import { SwiperSlide } from './esm/vue/swiper-slide';
export { Swiper, SwiperSlide };



//////////////////
// WEBPACK FOOTER
// ./~/swiper/swiper-vue.esm.js
// module id = 1234
// module chunks = 168